import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// Moved to `/manufacturing/activities/create`; old bookmarks and links still land here.
export const Route = createFileRoute('/_authenticated/manufacturing/add-activity')({
    // Only redirects: `create` checks its own access.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    beforeLoad: () => {
        throw redirect({ to: '/manufacturing/activities/create', search: true, replace: true });
    },
});
